import React from "react";

import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
	MainHeaderButtonsWrapper: {
		display: "flex",
		flexDirection: "row",
		alignItems: "center",
		flex: "none",
		marginLeft: "auto",
		flexWrap: "nowrap",
		"& > *": {
			margin: theme.spacing(0.5),
		},
	},
}));

const MainHeaderButtonsWrapper = ({ children }) => {
	const classes = useStyles();

	return <div className={classes.MainHeaderButtonsWrapper}>{children}</div>;
};

export default MainHeaderButtonsWrapper;
